import { stringArrayToObject } from '../../utils/array';

import I18n from '../../config/i18n';

import {
  loadManufacturerInfo,
  loadManufacturerCollections,
  assignManufacturer,
  dissociateManufacturer,
} from '../../services/ManufacturersService';

import { loadCollectionProducts } from '../../services/CollectionServices';

import { actionCreators as toastActions } from '../Toasts/actions';

export const actions = stringArrayToObject([
  'CLEAR',
  'LOAD_INFO_START',
  'LOAD_INFO_SUCCESS',
  'LOAD_INFO_FAIL',
  'LOAD_COLLECTIONS_START',
  'LOAD_COLLECTIONS_SUCCESS',
  'LOAD_COLLECTIONS_FAIL',
  'LOAD_COLLECTION_PRODUCTS_START',
  'LOAD_COLLECTION_PRODUCTS_SUCCESS',
  'LOAD_COLLECTION_PRODUCTS_FAIL',
  'START_ASSIGN',
  'END_ASSIGN_SUCCESS',
  'END_ASSIGN_FAIL',
], '@MANUFACTURER');

const privateActionCreators = {
  loadInfoStart() {
    return {
      type: actions.LOAD_INFO_START,
    };
  },
  loadInfoSuccess(info) {
    return {
      type: actions.LOAD_INFO_SUCCESS,
      payload: { info },
    };
  },
  loadInfoFail(error) {
    return {
      type: actions.LOAD_INFO_FAIL,
      payload: { error },
    };
  },
  loadCollectionsStart(page) {
    return {
      type: actions.LOAD_COLLECTIONS_START,
      payload: { page },
    };
  },
  loadCollectionsSuccess({ collections, page, totalPages }) {
    return {
      type: actions.LOAD_COLLECTIONS_SUCCESS,
      payload: { collections, page, totalPages },
    };
  },
  loadCollectionsFail(error) {
    return {
      type: actions.LOAD_COLLECTIONS_FAIL,
      payload: { error },
    };
  },
  loadCollectionProductsStart(id, page) {
    return {
      type: actions.LOAD_COLLECTION_PRODUCTS_START,
      payload: { id, page },
    };
  },
  loadCollectionProductsSuccess({
    id, products, page, totalPages,
  }) {
    return {
      type: actions.LOAD_COLLECTION_PRODUCTS_SUCCESS,
      payload: {
        id, products, page, totalPages,
      },
    };
  },
  loadCollectionProductsFail(id, error) {
    return {
      type: actions.LOAD_COLLECTION_PRODUCTS_FAIL,
      payload: { id, error },
    };
  },
  startAssign() {
    return {
      type: actions.START_ASSIGN,
    };
  },
  endAssignSuccess(assigned) {
    return {
      type: actions.END_ASSIGN_SUCCESS,
      payload: { assigned },
    };
  },
  endAssignFail(error) {
    return {
      type: actions.END_ASSIGN_FAIL,
      payload: { error },
    };
  },
};

export const actionCreators = {
  clearManufacturer() {
    return {
      type: actions.CLEAR,
    };
  },
  loadInfo(id) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadInfoStart());
      const response = await loadManufacturerInfo(id);
      if (response.ok) {
        dispatch(privateActionCreators.loadInfoSuccess(response.manufacturer));
      } else {
        dispatch(privateActionCreators.loadInfoFail(response.error));
      }
    };
  },
  loadCollections(id, page = 1) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadCollectionsStart(page));
      const response = await loadManufacturerCollections(id, page);
      if (response.ok) {
        dispatch(privateActionCreators.loadCollectionsSuccess(response));
      } else {
        dispatch(privateActionCreators.loadCollectionsFail(response.error));
      }
    };
  },
  loadCollectionProducts(id, page = 1) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadCollectionProductsStart(id, page));
      const response = await loadCollectionProducts(id, page);
      if (response.ok) {
        dispatch(privateActionCreators.loadCollectionProductsSuccess(response));
      } else {
        dispatch(privateActionCreators.loadCollectionProductsFail(id, response.error));
      }
    };
  },
  assignManufacturer(id) {
    return async (dispatch) => {
      dispatch(privateActionCreators.startAssign());
      const response = await assignManufacturer(id);
      if (response.ok) {
        dispatch(privateActionCreators.endAssignSuccess(true));
      } else {
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('screens.manufacturers.show.errors.notAssigned'),
        }));
        dispatch(privateActionCreators.endAssignFail(response.error));
      }
    };
  },
  dissociateManufacturer(id) {
    return async (dispatch) => {
      dispatch(privateActionCreators.startAssign());
      const response = await dissociateManufacturer(id);
      if (response.ok) {
        dispatch(privateActionCreators.endAssignSuccess(false));
      } else {
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('screens.manufacturers.show.errors.notDissociated'),
        }));
        dispatch(privateActionCreators.endAssignFail(response.error));
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Manufacturer/actions.js